import {h, JSX} from 'preact'
import {Modal} from './Modal'
import {TrashIcon} from './Icons';
import {NumberInput, NumberInputProps} from './NumberInput';
import {TextField, TextFieldProps} from './TextField';

export interface SummaryItemModalProps {
    title: string;
    show: boolean;
    price?: string;
    priceLabel?: string;
    unitPriceLabel?: string;
    quantityLabel?: string;
    closeLabel?: string;
    saveLabel?: string;
    onRemove?: () => void;
    onSave?: () => void;
    toggleModal: () => void;
    quantityInput?: NumberInputProps;
    priceField?: TextFieldProps;
}

export const SummaryItemModal = (props: SummaryItemModalProps): JSX.Element => (
    <Modal
        show={props.show}
        toggleModal={props.toggleModal}
        title={props.title}
        hasCloseButton
    >
        <div class='flex flex-col'>
            <div class='flex flex-col py-6 px-8 grow'>
                <table class='[&>tr+tr>td]:pt-6'>
                    {props.priceField && (
                        <tr>
                            <td class='font-semibold mr-6'>{props.unitPriceLabel}</td>
                            <td><TextField {...props.priceField}/></td>
                        </tr>
                    )}
                    {props.quantityInput && (
                        <tr>
                            <td class='font-semibold mr-6'>{props.quantityLabel}</td>
                            <td><NumberInput {...props.quantityInput}/></td>
                        </tr>
                    )}
                    {props.priceLabel && (
                        <tr>
                            <td class='font-semibold mr-6'>{props.priceLabel}</td>
                            <td class='font-semibold'>{props.price}</td>
                        </tr>
                    )}
                </table>
            </div>
            <div class='flex shrink justify-between items-center border-t px-8 py-6'>
                {props.onRemove && (
                    <button onClick={props.onRemove} class='btn btn-border p-3 text-kinola-red hover:text-kinola-red-h rounded-2xl'>
                        <TrashIcon/>
                    </button>
                )}
                <div class='flex gap-2.5'>
                    {props.closeLabel && (
                        <button onClick={props.toggleModal} class='btn btn-border p-4 text-base leading-[14px]'>
                            {props.closeLabel}
                        </button>
                    )}
                    {props.saveLabel && props.onSave && (
                        <button onClick={props.onSave} class='btn btn-light-blue p-4 text-base leading-[14px]'>
                            {props.saveLabel}
                        </button>
                    )}
                </div>
            </div>
        </div>
    </Modal>
);
